import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Button } from '@mui/material';
import { ClientsCancellationsSVG, ConsultantsSVG, FraudSVG } from '../../../components';
import enabledPages from '../../../constants/pages/enabledPages';
import { useTranslation } from 'react-i18next';
import { checkPermissions } from '../../../helpers/PermissionsChecker';

export default function ClientsDropMenu (clientsDropBadges) {
    const history = useHistory();
    const location = useLocation();
    const { t } = useTranslation();
    const routeClientsDrop = '/managment/checker';
    const routeConsultants = '/managment/consultants';
    const routeFraudPrevent = '/managment/fraudPrevention';
    const handleRoute = (path) => {
        history.push(path);
    };

    return (
        <div className='dropMenu' style={{ width: '95%' }}>
            <div>
                {
                    checkPermissions('show_management.sub_cancellations') &&
                <Button
                    className={location.pathname === routeClientsDrop ? 'button_subMenuActive' : 'button_subMenu'}
                    onClick={() => { handleRoute(routeClientsDrop); }}
                >
                    {location.pathname === routeClientsDrop ? <ClientsCancellationsSVG customStroke='white'/> : <ClientsCancellationsSVG/>}
                    <span className={location.pathname === routeClientsDrop ? 'button_subMenuActive-text' : 'button_subMenu-text'}>{t('management.unsubscription.title')}</span>
                    <div className={location.pathname === routeClientsDrop ? 'badges_count--active' : 'badges_count--inactive'}>
                        {clientsDropBadges.clientsDropBadges}
                    </div>
                </Button>
                }
                {enabledPages.enableConsultants && checkPermissions('show_management.sub_consultants') &&
                <Button
                    className={location.pathname.includes(routeConsultants) ? 'button_subMenuActive' : 'button_subMenu'}
                    onClick={() => { handleRoute(routeConsultants); }}
                >
                    {location.pathname.includes(routeConsultants) ? <ConsultantsSVG customStroke='white'/> : <ConsultantsSVG/>}
                    <span className={location.pathname.includes(routeConsultants) ? 'button_subMenuActive-text' : 'button_subMenu-text'}>{t('management.consultants.title')}</span>
                </Button>

                }
                {enabledPages.enableFraudPrevention && checkPermissions('show_management.sub_antifraud') &&
                <Button
                    className={location.pathname === routeFraudPrevent ? 'button_subMenuActive' : 'button_subMenu'}
                    onClick={() => { handleRoute(routeFraudPrevent); }}
                >
                    {location.pathname === routeFraudPrevent ? <FraudSVG customStroke={'white'}/> : <FraudSVG/>}
                    <span className={location.pathname === routeFraudPrevent ? 'button_subMenuActive-text' : 'button_subMenu-text'}>{t('management.fraudPrevention.title')}</span>
                </Button>
                }
            </div>
        </div>
    );
}
